import { Button, Modal } from "@dreambigger/design-system";
import { memo } from "react";
import { useModalAnalytics } from "@dreambigger/shared/src/hooks";

type Props = {
  visible: boolean;
  success: boolean;
  eventTitle: string;
  onClose: () => void;
};

const UnsubscribeModal = ({ visible, success, eventTitle, onClose }: Props) => {
  // Modal - Opened / Modal - Closed GA events (legacy parity)
  useModalAnalytics(visible, "UnsubscribeModal");

  return (
    <Modal open={visible} closable={false} footer={null} width={480} centered>
      {success ? (
        <div className="tc pa-4">
          <h3 className="f-5 fwb mb-4">You've Opted Out Successfully</h3>
          <p className="f-3 mb-4">
            You have been unsubscribed from emails related to your project{" "}
            {eventTitle}
          </p>
          <p className="f-2 gray mb-5">
            Please note that you will receive emails for any future Thrivent
            Action Team for which you are approved. You will have the option to
            unsubscribe from those emails as well. Made a mistake or change your
            mind? Email us at{" "}
            <a href="mailto:thrivent.action.teams@cotribute.com">
              thrivent.action.teams@cotribute.com
            </a>{" "}
            to start receiving emails again.
          </p>
          <Button type="primary" size="large" onClick={onClose}>
            Continue
          </Button>
        </div>
      ) : (
        <div className="tc pa-4">
          <h3 className="f-5 fwb mb-4">Unable to Unsubscribe!</h3>
          <p className="f-3 mb-5">
            Please contact our Customer Support team at{" "}
            <a href="mailto:help@cotributemail.com">help@cotributemail.com</a>.
          </p>
          <Button type="primary" size="large" onClick={onClose}>
            Continue
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default memo(UnsubscribeModal);
